import { assert_array_typeof_string, assert_instanceof } from '@shared/asserts/utils_asserts';
import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';
import { DTO_GRAPH__instance } from '../../_graph/DTO_GRAPH__instance';
import { FIELD_GRID2D_MODE__base } from '../_base/FIELD_GRID2D_MODE__base';
import { FIELD__list_token } from '../_primitives/list/FIELD__list_token';
import { FIELD__token } from './FIELD__token';

export class FIELD_GRID2D_MODE__token_after_token extends FIELD_GRID2D_MODE__base {
  /*
   * STATIC FIELDS
   */

  static _class_name_static = ENUM__dto_class_name.GRAPH_FIELD_GRID2D_MODE__TOKEN_AFTER_TOKEN;

  /*
   *
   */
  tokens: string[];
  tokens_sequences!: string[][];

  /*
   * FIELDS
   */
  //todo: finish tokens positions
  // @FIELD_PRIMITIVE__int.init_as_field(
  //   {
  //     value: 0,
  //     value_range: DTO__number_range.ZERO.clone(),
  //     values_allowed: DTO__number_range.ZERO.clone(),
  //     //
  //     slider_step: 1,
  //     slider_step_values: [1, 2, 3, 4, 5],
  //   },
  //   { ui__has_component: false, grid2d__can_be_dimension: false },
  // )
  // tokens_positions!: FIELD_PRIMITIVE__int;

  /*
   *
   */

  get grid2d_dimension_values() {
    return this.tokens_sequences;
  }

  /*
   *
   */

  constructor() {
    super();

    this.tokens = [];
    this.tokens_sequences = [[]];
  }

  init_tokens(tokens: FIELD__token[]) {
    // Map over the items and slice the array from index 0 up to the current index + 1
    this.tokens_sequences = tokens.map((_, index) => tokens.slice(0, index + 1).map(token => token.word_english.get_value()));

    if (this.tokens_sequences.is_empty()) this.tokens_sequences = [[]];

    /*
     *
     */
    //todo: finish tokens positions
    // if (this.tokens_sequences.is_empty()) {
    //   this.tokens_sequences.push([]);
    //   this.tokens_positions.set_value_range(DTO__number_range.ZERO.clone());
    //   this.tokens_positions.values_allowed = DTO__number_range.ZERO.clone();
    // } else {
    //   let values_allowed = new DTO__number_range(1, this.tokens_sequences.length);
    //   this.tokens_positions.values_allowed = values_allowed.clone();

    //   let values_range_current = this.tokens_positions.get_value_range();

    //   let value_range_new = values_allowed.clamp_range(values_range_current);
    //   this.tokens_positions.set_value_range(value_range_new);
    // }
  }

  grid2d_dimension__set_value(tokens_sequence: any) {
    assert_array_typeof_string(tokens_sequence);

    this.tokens = [...tokens_sequence];
    this.tokens_sequences = [[]];
  }

  grid2d_dimension__apply_for(graph: DTO_GRAPH__instance) {
    let fields_map = graph.fields__get_map();
    let tokens_list = fields_map.values().find_or_assert(field => field instanceof FIELD__list_token);
    assert_instanceof(tokens_list, FIELD__list_token);

    tokens_list.items = tokens_list.get_tokens_by_words_english(this.tokens);
    tokens_list.field_name_and_path__fill_for_children();

    graph.field__replace(tokens_list);
  }
}
